import { ref, computed, resolveComponent, createBlock, openBlock, withCtx, createVNode, createTextVNode, toDisplayString, createElementBlock, Fragment, renderList, createElementVNode, normalizeClass, normalizeProps, guardReactiveProps } from "vue";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import { VCard, VCardTitle, VCardText } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import { VDivider } from "vuetify/components/VDivider";
import { VListSubheader, VListItem, VListItemTitle } from "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import { VMenu } from "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import { VIcon } from "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                    */
import "vuetify/components/VInfiniteScroll";
/* empty css                         */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                 */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                            */
import "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/lookups.js";
import "../../graphql/entity.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _sfc_main = {
  __name: "BooleanFilterItem",
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    returnObject: Boolean,
    multi: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: "lets-icons:done-all-round-duotone"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emits = __emit;
    const props = __props;
    const { t } = useI18n();
    const items = ref([
      { name: t("base.buttons.yes"), value: true },
      { name: t("base.buttons.no"), value: false }
    ]);
    const value = computed({
      get: () => props.modelValue,
      set: (val) => emits("update:modelValue", val)
    });
    const getItemIndex = (item) => {
      return value.value.findIndex((v) => v.value === item.value);
    };
    const switchSelectedValue = (item) => {
      const index = getItemIndex(item);
      if (index > -1) {
        value.value.splice(index, 1);
      } else {
        if (!props.multi) {
          value.value.splice(0);
        }
        value.value.push(props.returnObject ? item : item.id);
      }
    };
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      return openBlock(), createBlock(VMenu, {
        width: "350",
        offset: "8",
        class: "banza-boolean-filter-item",
        "close-on-content-click": false,
        location: "end"
      }, {
        activator: withCtx(({ props: activatorProps }) => [
          createVNode(VListItem, normalizeProps(guardReactiveProps(activatorProps)), {
            prepend: withCtx(() => [
              createVNode(_component_b_icon, {
                size: "20",
                class: "mr-2",
                icon: __props.icon
              }, null, 8, ["icon"])
            ]),
            append: withCtx(() => [
              createVNode(VIcon, null, {
                default: withCtx(() => _cache[0] || (_cache[0] = [
                  createTextVNode("mdi-chevron-right")
                ])),
                _: 1,
                __: [0]
              })
            ]),
            default: withCtx(() => [
              createVNode(VListItemTitle, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.label), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        default: withCtx(() => [
          createVNode(VCard, { class: "rounded-lg banza-lookup-filter-card" }, {
            default: withCtx(() => [
              createVNode(VCardTitle, { class: "pa-0" }, {
                default: withCtx(() => [
                  createVNode(VListSubheader, { class: "banza-filter--header py-3 pl-3" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.label), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(VDivider)
                ]),
                _: 1
              }),
              createVNode(VCardText, { class: "pr-0 pl-0 pb-1" }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (item, i) => {
                    return openBlock(), createBlock(VListItem, {
                      key: i,
                      onClick: ($event) => switchSelectedValue(item)
                    }, {
                      default: withCtx(() => [
                        createElementVNode("div", {
                          class: normalizeClass([
                            "banza--item checkbox--item d-flex align-center px-1",
                            getItemIndex(item) > -1 ? "selected" : "",
                            __props.multi ? "" : "circle"
                          ])
                        }, [
                          _cache[1] || (_cache[1] = createElementVNode("div", { class: "r--icon flex-shrink-0" }, null, -1)),
                          createTextVNode(" " + toDisplayString(item.name), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]);
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
